<h2 mat-dialog-title>
  <mat-icon class="icon-24" svgIcon="icon_transverse_discount"></mat-icon>
  Tværgående rabatter
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <div class="multi-select">
    <div class="multi-select__list">
      @for (discount of discounts$ | async; track discount) {
        <div
          class="multi-select__item multi-select__item--tall"
          [class.highlight]="discount.identifier === discountGroupBeingEdited?.identifier">
          <div class="multi-select__item--name">
            <strong>Navn:</strong>
            <span>&nbsp;{{ discount.name }}</span>
          </div>
          <div class="multi-select__item--discount">
            <strong>Type </strong>
            <span>{{ discount.discount_type | translateOrganizationDiscountType }}</span>
          </div>
          <div class="multi-select__item--discount">
            <strong>Rabat </strong>
            <span>{{ discount.amount | dotToComma }} {{ discount.discount_type | translateOrganizationDiscountType }}</span>
          </div>
          <div class="multi-select__item--carType">
            <strong>Tilknytninger: </strong>
            @if (discount.attached_access_group_count > 0) {
              <a
                class="blue"
                mat-dialog-close
                [routerLink]="['/access-groups']"
                [queryParams]="{ sharedDiscountIdentifier: discount.identifier }">
                {{ discount.attached_access_group_count }}
              </a>
            }
            @if (discount.attached_access_group_count === 0) {
              <span>0</span>
            }
          </div>
          <button mat-icon-button title="Rediger" type="button" (click)="edit(discount)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
          </button>
          <button mat-icon-button class="delete" title="Fjern" type="button" (click)="remove(discount)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
          </button>
        </div>
      }
      <div class="multi-select__input">
        <form class="filter-dropdown" [formGroup]="form">
          <mat-form-field>
            <mat-label>Navn</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Vælg type</mat-label>
            <mat-select formControlName="discountType" okCustomDropDownArrowDirective data-pw="sharedDiscountTypeSelector">
              @for (discountType of discountTypes | enumToArray | translateOrganizationDiscountType; track discountType) {
                <mat-option [value]="discountType.index">
                  {{ discountType.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix></mat-icon>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Rabat</mat-label>
            <input type="number" matInput formControlName="amount" />
            @if (form.controls.amount.hasError('min') || form.controls.amount.hasError('max')) {
              <mat-error>
                <div>Rabatten skal være en værdi mellem 0 og 100</div>
              </mat-error>
            }
          </mat-form-field>

          @if (!discountGroupBeingEdited) {
            <button mat-flat-button color="primary" (click)="create()" class="add-button" [disabled]="form.invalid">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
            </button>
          }

          @if (discountGroupBeingEdited) {
            <button mat-flat-button color="primary" (click)="update()" class="add-button" [disabled]="form.invalid">Gem</button>
          }
        </form>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
